import React from 'react'
import Html from './html'
import CustomTable from './custom-table'
import Documents from './Documents'

export default {
  html: Html,
  documents: Documents,
  'custom-table': CustomTable,
  multiplierField: (props) => <span style={{ paddingLeft: 24, fontStyle: 'italic' }}>{props.label}</span>,
}
